// NB: var is used over const, to maintain consistency of JS codebase, which
// natively targets ES5.

// Module variable names should take the form of 'MODULE_NAME__MY_MODULE'
// Event variable names should take the form of 'EVENT_NAME__MY_MODULE__MY_EVENT'
// Event strings should take the form of 'generalEventScope_eventName'
// -- in the case of a global event, the module part should be the type of global event
// -- i.e. "EVENT_NAME__GENERAL__MY_EVENT" or "EVENT_NAME__LOADED_MY_EVENT"

// ##############################################################################
// Plugin names
// ##############################################################################

var PLUGIN_NAME__JDA_BESPOKE_EMBED = 'jdaBespokeEmbed';
var PLUGIN_NAME__JDA_UPLOAD = 'jdaUpload';
var PLUGIN_NAME__JDA_VIDEO_INPUT = 'jdaVideoInput';

// ##############################################################################
// Module names
// ##############################################################################

var MODULE_NAME__AUXNAV = 'auxNav';
var MODULE_NAME__CONFIRM_ENTRY_SUBMIT = 'confirmEntrySubmit';
var MODULE_NAME__CONFIRM_ENTRY_CANCEL = 'confirmEntryCancel';
var MODULE_NAME__CONTACT_FORM = 'contactForm';
var MODULE_NAME__DASHBOARD = 'dashboard';
var MODULE_NAME__DUALPANE = 'dualPane';
var MODULE_NAME__ENTER_FORM = 'enterForm';
var MODULE_NAME__FOOTER = 'footer';
var MODULE_NAME__FORGOTTEN_PASSWORD_FORM = 'forgottenPasswordForm';
var MODULE_NAME__GALLERY = 'gallery';
var MODULE_NAME__GALLERY_FILTERS = 'galleryFilters';
var MODULE_NAME__GALLERY_TITLE_BAR = 'galleryTitleBar';
var MODULE_NAME__GEO_SELECT = 'geoSelect';
var MODULE_NAME__HEADINGS_AREA = 'headingsArea';
var MODULE_NAME__MAIN_NAV = 'mainNav';
var MODULE_NAME__PREVIEW_BAR = 'previewBar';
var MODULE_NAME__NEWS = 'news';
var MODULE_NAME__NEWS_ARTICLE_PAGE = 'newsArticlePage';
var MODULE_NAME__NEWSLETTER_CTA = 'newsletterCta';
var MODULE_NAME__NEWSLETTER_FOOTER_CTA = 'newsletterFooterCta';
var MODULE_NAME__PROFILE_FORM = 'profileForm';
var MODULE_NAME__REGISTER_FORM = 'registerForm';
var MODULE_NAME__RESET_PASSWORD_FORM = 'resetPasswordForm';
var MODULE_NAME__SIGN_IN_FORM = 'signInForm';
var MODULE_NAME__SOCIAL_LINKS = 'socialLinks';
var MODULE_NAME__STICKY_FOLLOWER_TOP = 'stickyFollowerTop';
var MODULE_NAME__UPLOAD_IMAGES_CAPTIONS = 'uploadImagesCaptions';
var MODULE_NAME__SOCIAL_MEDIA_SHARE_POPUP = 'socialMediaSharePopup';
var MODULE_NAME__PROJECT_PAGE = 'projectPage';
var MODULE_NAME__NEWSLETTER_FLASH_CTA = 'newsletterFlashCta';
var MODULE_NAME__COLLAPSIBLE_PANEL = 'collapsiblePanel';
var MODULE_NAME__HOME_PAGE = 'homePage';
var MODULE_NAME__CTA_COLLECTION = 'ctaCollection';
var MODULE_NAME__CORE_CONTENT = 'coreContent';
var MODULE_NAME__WRAP_MAIN_BTNS = 'wrapMainBtns';
var MODULE_NAME__VIDEO_LIGHTBOX = 'videoLightbox';

// ##############################################################################
// Event names: Modules
// ##############################################################################

// Auxnav
var EVENT_NAME__AUXNAV__LANGUAGE_SELECT_BUTTON_CLICKED = MODULE_NAME__AUXNAV + '_languageSelectOpenRequested';

// Confirm entry submit
var EVENT_NAME__CONFIRM_ENTRY_SUBMIT__SAVE_BUTTON_TRIGGERED = MODULE_NAME__CONFIRM_ENTRY_SUBMIT + '_saveButtonTriggered';
var EVENT_NAME__CONFIRM_ENTRY_SUBMIT__CONFIRM_BUTTON_TRIGGERED = MODULE_NAME__CONFIRM_ENTRY_SUBMIT + '_confirmButtonTriggered';
var EVENT_NAME__CONFIRM_ENTRY_SUBMIT__MODAL_CLOSED = MODULE_NAME__CONFIRM_ENTRY_SUBMIT + '_closed';

// Contact form
var EVENT_NAME__CONTACT_FORM__INITIATED = MODULE_NAME__CONTACT_FORM + '_initiated';

// Core content
var EVENT_NAME__CORE_CONTENT__USER_LINGERD_ON_NON_PROJECT_PAGE = MODULE_NAME__CORE_CONTENT + '_userLingeredOnNonProjectPage';

// Dashboard
var EVENT_NAME__DASHBOARD__INITIATED = MODULE_NAME__DASHBOARD + '_initiated';

// Enter form
var EVENT_NAME__ENTER_FORM__INITIATED = MODULE_NAME__ENTER_FORM + '_initiated';
var EVENT_NAME__ENTER_FORM__VALID_SUBMIT = MODULE_NAME__ENTER_FORM + '_validSubmit';
var EVENT_NAME__ENTER_FORM__CANCEL_PRESSED = MODULE_NAME__ENTER_FORM + '_cancelPressed';
var EVENT_NAME__ENTER_FORM__PROJECT_NAME_CHANGED = MODULE_NAME__ENTER_FORM + '_projectNameChanged';
var EVENT_NAME__ENTER_FORM__CONSTRAINTS_CHANGED = MODULE_NAME__ENTER_FORM + '_constraintsChanged';
var EVENT_NAME__ENTER_FORM__LANGUAGE_STRINGS_SET_FOR_THE_FIRST_TIME = MODULE_NAME__ENTER_FORM + '_languageStringsSetForTheFirstTime';
var EVENT_NAME__ENTER_FORM__SUBMIT_UI_DISABLED = MODULE_NAME__ENTER_FORM + '_submitUiDisabled';
var EVENT_NAME__ENTER_FORM__SUBMIT_UI_ENABLED = MODULE_NAME__ENTER_FORM + '_submitUiEnabled';
var EVENT_NAME__ENTER_FORM__IMAGE_DOESNT_EXIST = MODULE_NAME__ENTER_FORM + '_imageDoesntExist';

// Enter form
var EVENT_NAME__SIGN_IN_FORM__INITIATED = MODULE_NAME__SIGN_IN_FORM + '_initiated';

// Forgotten password form
var EVENT_NAME__FORGOTTEN_PASSWORD_FORM__INITIATED = MODULE_NAME__FORGOTTEN_PASSWORD_FORM + '_initiated';

// Gallery
var EVENT_NAME__GALLERY__GALLERY_WITH_INFINITE_SCROLL_INITIATED = MODULE_NAME__GALLERY + '_withInfiniateScrollInitiated';
var EVENT_NAME__GALLERY__GALLERY_INITIATED = MODULE_NAME__GALLERY + '_initiated';
var EVENT_NAME__GALLERY__BOTTOM_OF_INFINITE_SCROLL_REACHED = MODULE_NAME__GALLERY + '_bottomOfInfiniteScrollReached';
var EVENT_NAME__GALLERY__ITEM_LIST_UPDATED = MODULE_NAME__GALLERY + '_itemListUpdated';
var EVENT_NAME__GALLERY__FILTER_DATA_RESTORED = MODULE_NAME__GALLERY + '_filterDataRestored';

// Gallery filters
var EVENT_NAME__GALLERY_FILTERS__INITIATED = MODULE_NAME__GALLERY_FILTERS + '_initiated';
var EVENT_NAME__GALLERY_FILTERS__CLOSED = MODULE_NAME__GALLERY_FILTERS + '_closed';
var EVENT_NAME__GALLERY_FILTERS__OPENED = MODULE_NAME__GALLERY_FILTERS + '_opened';
var EVENT_NAME__GALLERY_FILTERS__NEW_FILTER_DATA_APPLIED = MODULE_NAME__GALLERY_FILTERS + '_newFilterDataApplied';

// Gallery title bar
var EVENT_NAME__GALLERY_TITLE_BAR__INITIATED = MODULE_NAME__GALLERY_TITLE_BAR + '_initiated';
var EVENT_NAME__GALLERY_TITLE_BAR__OPEN_FILTERS_BUTTON_CLICKED = MODULE_NAME__GALLERY_TITLE_BAR + '_openFiltersButtonClicked';
var EVENT_NAME__GALLERY_TITLE_BAR__NEW_FILTER_DATA_APPLIED = MODULE_NAME__GALLERY_TITLE_BAR + '_newFilterDataApplied';

// Geo select
var EVENT_NAME__GEO_SELECT__CLOSED = MODULE_NAME__GEO_SELECT + '_closed';
var EVENT_NAME__GEO_SELECT__OPENED = MODULE_NAME__GEO_SELECT + '_opened';

// Headings area
var EVENT_NAME__HEADINGS_AREA__VIDEO_PLAY_BUTTON_ACTIVATED = MODULE_NAME__HEADINGS_AREA + '_videoPlayButtonActivated';

// Main nav
var EVENT_NAME__MAIN_NAV__LANGUAGE_SELECT_BUTTON_CLICKED = MODULE_NAME__MAIN_NAV + '_languageSelectButtonClicked';
var EVENT_NAME__MAIN_NAV__OPENING = MODULE_NAME__MAIN_NAV + '_opening';
var EVENT_NAME__MAIN_NAV__OPENED = MODULE_NAME__MAIN_NAV + '_opened';
var EVENT_NAME__MAIN_NAV__CLOSING = MODULE_NAME__MAIN_NAV + '_closing';
var EVENT_NAME__MAIN_NAV__CLOSED = MODULE_NAME__MAIN_NAV + '_closed';

// News
var EVENT_NAME__NEWS__PREINIT = MODULE_NAME__NEWS + '_preinit';
var EVENT_NAME__NEWS__INITIATED = MODULE_NAME__NEWS + '_initiated';

// Profile form
var EVENT_NAME__PROFILE_FORM__INITIATED = MODULE_NAME__PROFILE_FORM + '_initiated';
var EVENT_NAME__PROFILE_FORM__IMAGE_DOESNT_EXIST = MODULE_NAME__PROFILE_FORM + '_imageDoesntExist';

// Register form
var EVENT_NAME__REGISTER_FORM__INITIATED = MODULE_NAME__REGISTER_FORM + '_initiated';
var EVENT_NAME__REGISTER_FORM__IMAGE_DOESNT_EXIST = MODULE_NAME__REGISTER_FORM + '_imageDoesntExist';

// Collapsible panel
var EVENT_NAME__COLLAPSIBLE_PANEL__INITIATED = MODULE_NAME__COLLAPSIBLE_PANEL + '_initiated';

// Sticky follower top
var EVENT_NAME__STICKY_FOLLOWER_TOP__WITH_STICKY_INITIATED = MODULE_NAME__STICKY_FOLLOWER_TOP + '_withStickyInitiated';

// Reset password form
var EVENT_NAME__RESET_PASSWORD_FORM__INITIATED = MODULE_NAME__RESET_PASSWORD_FORM + '_initiated';

// Sign in form
var EVENT_NAME__SIGN_IN_FORM__INITIATED = MODULE_NAME__SIGN_IN_FORM + '_initiated';

// Social media share popup
var EVENT_NAME__SOCIAL_MEDIA_SHARE_POPUP__CLOSED = MODULE_NAME__SOCIAL_MEDIA_SHARE_POPUP + '_closed';

// Upload images captions
var EVENT_NAME__UPLOAD_IMAGES_CAPTIONS__CARDS_REORDERED = MODULE_NAME__UPLOAD_IMAGES_CAPTIONS + '_cardsReordered';
var EVENT_NAME__UPLOAD_IMAGES_CAPTIONS__FILE_UPLOAD_STARTED = MODULE_NAME__UPLOAD_IMAGES_CAPTIONS + '_fileUploadStarted';
var EVENT_NAME__UPLOAD_IMAGES_CAPTIONS__FILE_UPLOAD_COMPLETE = MODULE_NAME__UPLOAD_IMAGES_CAPTIONS + '_fileUploadComplete';
var EVENT_NAME__UPLOAD_IMAGES_CAPTIONS__FILE_REMOVED = MODULE_NAME__UPLOAD_IMAGES_CAPTIONS + '_fileRemoved';

// Project page
var EVENT_NAME__PROJECT_PAGE__SOCIAL_MEDIA_SHARE_BUTTON_CLICKED = MODULE_NAME__PROJECT_PAGE + '_socialMediaShareButtonClicked';

// News article page
var EVENT_NAME__NEWS_ARTICLE_PAGE__SOCIAL_MEDIA_SHARE_BUTTON_CLICKED = MODULE_NAME__NEWS_ARTICLE_PAGE + '_socialMediaShareButtonClicked';

// Newsletter signup sticky/flash CTA
var EVENT_NAME__NEWSLETTER_FLASH_CTA__BUTTON_CLICKED = MODULE_NAME__NEWSLETTER_FLASH_CTA + '_newsletterFlashCta';

// Home page
var EVENT_NAME__HOME_PAGE__SOCIAL_MEDIA_SHARE_BUTTON_CLICKED = MODULE_NAME__HOME_PAGE + '_socialMediaShareButtonClicked';

// Video lightbox
var EVENT_NAME__VIDEO_LIGHTBOX__PLAYING = MODULE_NAME__VIDEO_LIGHTBOX + '_playing';
var EVENT_NAME__VIDEO_LIGHTBOX__PAUSED = MODULE_NAME__VIDEO_LIGHTBOX + '_paused';
var EVENT_NAME__VIDEO_LIGHTBOX__CLOSED = MODULE_NAME__VIDEO_LIGHTBOX + '_closed';

// ##############################################################################
// Event names: Plugins
// ##############################################################################

// JDA bespoke embed
var EVENT_NAME__JDA_BESPOKE_EMBED__THUMBNAIL_FOUND = PLUGIN_NAME__JDA_BESPOKE_EMBED + '_thumbnailFound';
var EVENT_NAME__JDA_BESPOKE_EMBED__HTML_REPLACED = PLUGIN_NAME__JDA_BESPOKE_EMBED + '_htmlReplaced';

// JDA upload
var EVENT_NAME__JDA_UPLOAD__FILES_SET = PLUGIN_NAME__JDA_UPLOAD + '_filesSet';
var EVENT_NAME__JDA_UPLOAD__FILE_REMOVED = PLUGIN_NAME__JDA_UPLOAD + '_fileRemoved';

// JDA video input
var EVENT_NAME__JDA_VIDEO_INPUT__INVALID_VIDEO_URL = PLUGIN_NAME__JDA_VIDEO_INPUT + '_filesSet';

// ##############################################################################
// Event names: General
// ##############################################################################

var EVENT_NAME__GENERAL__RESIZE = 'resize';
var EVENT_NAME__GENERAL__SCROLL = 'scroll';
var EVENT_NAME__GENERAL__SCROLL_START = 'scrollStart';
var EVENT_NAME__GENERAL__SCROLL_STOP = 'scrollStop';
var EVENT_NAME__GENERAL__RESOURCE_LOADED = 'resourceLoaded';

// ##############################################################################
// Resource names
// ##############################################################################

var RESOURCE_NAME__DOM = 'dom';
var RESOURCE_NAME__YOUTUBE = 'youtube';
var RESOURCE_NAME__GOOGLE_RECAPTCHA = 'googleRecaptcha';